/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ConnectionStatus } from './connectionStatus';
import type { ConnectionViewDirection } from './connectionViewDirection';
import type { ConnectionPeer } from './connectionPeer';
import type { ConnectionOccasion } from './connectionOccasion';

/**
 * Connection edge as seen by the authenticated participant.
 */
export interface ConnectionView {
  id: string;
  status: ConnectionStatus;
  direction: ConnectionViewDirection;
  peer: ConnectionPeer;
  occasion: ConnectionOccasion;
  requestedBy: string;
}
